import React from 'react'
import './ScreenHeading.css'

const ScreenHeading = (props) => {
  return (
    <div className='headContainer'>
        <div className='screenHead'>
            <span>{props.title}</span>
        </div>
        {
            (props.subHeading)?(
                <div className="screenSubHead">
                    <span>{props.subHeading}</span>
                </div>
            ):<div></div>
        }

        <div className='headSeperator'>
            <div className='seperLine'>
                <div className='sepeBlob'>
                    <div></div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ScreenHeading